import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation UserGroupBatchImport($groups: String!) {
        user_group_batch_import(groups: $groups) {
            success,
            createdCount: created_count,
            createdUids: created_uids,
            skipped,
        }
    }
`;

export interface IUserGroupBatchImportResult {
    success: boolean,
    createdCount: number,
    createdUids: string[],
    skipped: string[],
}

export async function userGroupBatchImport(groups: object[]): Promise<IUserGroupBatchImportResult> {
    const result: FetchResult<{ user_group_batch_import: IUserGroupBatchImportResult }> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { groups: JSON.stringify(groups) },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.user_group_batch_import;
}
